import React from 'react';
import ReactDOM from 'react-dom';

import SearchFiltersContainer from './SearchFiltersContainer';
import PaginationContainer from '../common/PaginationContainer';
import ResultsListContainer from '../common/ResultsListContainer';
import CollectionSearchContainer from '../common/CollectionSearchContainer';

import ResultItemContainer from './results/ResultItemContainer';
const rootElement = document.getElementById('course-search-results');

const collectionUrl = document.body.getAttribute('data-base-url');

const vocabularyDomain = 'unife.iuss.vocabularies';
const vocabularyNames = [
  'PhDTypesCatalog',
  'DepartmentsCatalog',
  'LanguagesCatalog',
  'EducationalActivitiesCatalog',
  'Durations',
];

ReactDOM.createRoot(rootElement).render(
  <CollectionSearchContainer
    collectionUrl={collectionUrl}
    vocabularyDomain={vocabularyDomain}
    vocabularyNames={vocabularyNames}
    translationsDomain="unife.iussumstheme"
  >
    <SearchFiltersContainer />
    <ResultsListContainer resultItemContainer={ResultItemContainer} />
    <PaginationContainer />
  </CollectionSearchContainer>
);
